<template>
	<div class="content-container">
		BLANK CONTENT CONTAINER	
	</div>
</template>


<script>
	export default {
		name: 'content-container',
		components: {

		},
		props: [

		],
		data:() => ({

		}),
		computed: {

		},
		methods: {

		}
	}
</script>